"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/components/auth/Auth";
import styles from "@/components/nft-image/NFTImage.module.scss";
import { useNftBalance } from "@/hooks/useNftBalance";
interface Props {
  readonly contract: string;
  readonly tokenId: number;
  readonly height: 300 | 650 | "full";
}
export default function NFTImageBalance(t0) {
  const $ = _c(11);
  const {
    contract,
    tokenId,
    height
  } = t0;
  const {
    connectedProfile
  } = useAuth();
  const t1 = connectedProfile?.consolidation_key ?? null;
  let t2;
  if ($[0] !== contract || $[1] !== t1 || $[2] !== tokenId) {
    t2 = {
      consolidationKey: t1,
      contract,
      tokenId
    };
    $[0] = contract;
    $[1] = t1;
    $[2] = tokenId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    balance: nftBalance,
    isLoading,
    error
  } = useNftBalance(t2);
  let t3;
  let t4;
  if ($[4] !== connectedProfile || $[5] !== error || $[6] !== height || $[7] !== isLoading || $[8] !== nftBalance) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const printBalance = () => {
        if (nftBalance > 0) {
          return printBalanceSpan(`SEIZED x${nftBalance}`);
        } else {
          return printBalanceSpan("UNSEIZED");
        }
      };
      const printBalanceSpan = b => <span className={`${styles.balance} ${height === 650 ? styles.balanceBigger : ""} `}>{b}</span>;
      if (!connectedProfile) {
        t4 = null;
        break bb0;
      }
      if (isLoading) {
        t4 = printBalanceSpan("...");
        break bb0;
      }
      if (error) {
        console.error("Failed to fetch NFT balance:", error);
        t4 = printBalanceSpan("N/A");
        break bb0;
      }
      t3 = printBalance();
    }
    $[4] = connectedProfile;
    $[5] = error;
    $[6] = height;
    $[7] = isLoading;
    $[8] = nftBalance;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  return t3;
}